import BaseTaskRow from "./BaseTaskRow";
import OtherTasksNameCellRenderer from "../renderers/OtherTasksNameCellRenderer";
import OtherTasksCellRenderer from "../renderers/OtherTasksCellRenderer";

export default class OtherTasksRow extends BaseTaskRow {
    createRowHeaderRenderer() {
        return new OtherTasksNameCellRenderer();
    }

    getTopBorderClass() {
        let topBorderClass = BaseTaskRow.prototype.getTopBorderClass.call(this);
        if (!topBorderClass) {
            return "notAvailableTaskDetailsTopSeparator";
        }
        return topBorderClass;
    }

    createLockCellRenderer() {
        return new OtherTasksCellRenderer(this.appendOddEvenPrefix("DayDetailsCell"), this.getTopBorderClass());
    }
}


// WEBPACK FOOTER //
// ./web/js/locktable/rows/OtherTasksRow.js